<script lang="ts">
  import { entries, byCategory } from "../content";
  import { readSet } from "../stores";

  $: onboarding = byCategory($entries, "onboarding");
  $: total = onboarding.length;
  $: done = onboarding.filter((s) => $readSet.has(s.slug)).length;
  $: pct = total === 0 ? 0 : Math.round((done / total) * 100);

  // SVG ring geometry.
  $: r = 22;
  $: c = 2 * Math.PI * r;
  $: dash = (pct / 100) * c;
</script>

{#if total > 0}
  <div class="panel p-5 flex items-center gap-4">
    <svg width="56" height="56" viewBox="0 0 56 56" class="shrink-0">
      <!-- Track ring inherits color from a parent <g> so the theme can flip
           it via Tailwind classes (text-border in dark = #2a2a2a, in light =
           the lighter border value) without inline hex. -->
      <g class="text-border">
        <circle cx="28" cy="28" r={r} fill="none" stroke="currentColor" stroke-width="4" />
      </g>
      <g class="text-accent">
        <circle
          cx="28"
          cy="28"
          r={r}
          fill="none"
          stroke="currentColor"
          stroke-width="4"
          stroke-linecap="round"
          stroke-dasharray="{dash} {c}"
          transform="rotate(-90 28 28)"
        />
      </g>
      <g class="text-text">
        <text
          x="28"
          y="28"
          text-anchor="middle"
          dominant-baseline="middle"
          fill="currentColor"
          font-size="13"
          font-weight="600"
        >
          {pct}%
        </text>
      </g>
    </svg>
    <div class="flex-1 min-w-0">
      <div class="text-sm font-semibold text-text">Onboarding progress</div>
      <div class="text-xs text-text-muted">
        {done} of {total} complete · keep going
      </div>
    </div>
  </div>
{/if}
